/**
 * Singleton for expire tooltips (DateExpiredChecker).
 * When one tooltip opens, the previous one is closed.
 */
let activeClose = null

export const requestOpen = (closeFn) => {
  if (activeClose) {
    activeClose()
  }
  activeClose = closeFn
}

export const release = (closeFn) => {
  if (activeClose === closeFn) {
    activeClose = null
  }
}
